module.exports = __webpack_public_path__ + "h5/img/weixin.3f6c2311.png";